module.exports = __webpack_public_path__ + "static/media/arrowDownIcon.b31a433c.svg";